import * as t from 'io-ts';
import {
  Empty,
  Offer,
  Operators,
  NameUrl,
  Routes,
  TopOperatorRoute,
  Template,
  MySafetyHtmls,
  BusAmenities,
  BusReviews,
  LeaveIntentOffer,
  RtcData,
  SeoOfferData,
} from '../../pages/runtime-typechecker';

export const OperatorTemplateDataChecker = t.type({
  id: t.number,
  operatorName: t.string,
  noOfRoutes: t.number,
  noOfBuses: t.number,
  areaServed: t.array(t.string),
  ownedBy: t.string,
  headOffice: t.string,
  isActive: t.boolean,
  Show404: t.union([t.boolean, t.null, t.undefined]),
  urlPhrase: t.string,
  url: t.string,
  description: t.union([t.string, t.null]),
  additionalInfo: t.union([t.string, t.null]),
  htmlRefreshDate: t.union([t.string, t.null]),
  created: t.string,
  modified: t.string,
  templateData: Template,
  topRoutesList: t.array(TopOperatorRoute),
  busAmenities: t.array(BusAmenities),
  busTypes: t.array(t.string),
  busReviews: t.array(BusReviews),
  busImagesUrl: t.array(t.string),
  routesList: t.array(Routes),
  rtcTypeLinks: t.array(NameUrl),
  popularCitiesForRtc: t.array(NameUrl),
  status: t.string,
  offers: t.union([t.undefined, t.array(Offer)]),
  mySafetyHtmls: MySafetyHtmls,
  otherOperatorLinks: t.array(Operators),
  leaveIntentOffers: t.array(LeaveIntentOffer),
  rtcData: RtcData || null,
  seoOfferData: t.array(SeoOfferData),
  schemaInfo: t.union([t.undefined, t.null, t.string]),
});
export type OperatorTemplateData = t.TypeOf<typeof OperatorTemplateDataChecker>;
